import {connect} from 'react-redux';
import {get} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {CSBPlusReportEndDate} from '/enum/dates.enum';
import {userId} from '/redux/selector/currentUser.selector';
import {
  bonusEarnedAccelById,
  bonusEarnedClientSupportPlusById,
  bonusEligibleForAccelById,
  bonusEligibleForCabById,
  bonusEligibleForClientSupportPlusById,
  bonusEligibleForIncentiveTripById,
  bonusEligibleForQsbById,
  coachesRankUpById,
  eligibleForQsbCountById,
  fiveToSixCSBPClientCountById,
  oneToTwoCSBPClientCountById,
  sevenToNineCSBPClientCountById,
  threeToFourCSBPClientCountById,
} from '/redux/selector/metric.teams.selector';
import {
  variablesBonusDisplayDate,
  variablesFeatureFlag,
} from '/redux/selector/remoteConfig.selector';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {shouldReleaseFeature} from '/util/featureRelease.util';
import {withProps} from '/util/selector.util';

import BonusesSection from './BonusesSection';

const withCoachUserId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    eligibleForAccelBonusCount: withCoachUserId(bonusEligibleForAccelById),
    clientAcquisitionBonus: withCoachUserId(bonusEligibleForCabById),
    quickStartBonus: withCoachUserId(bonusEligibleForQsbById),
    threeToFourCSBPClientCount: withCoachUserId(threeToFourCSBPClientCountById),
    oneToTwoCSBPClientCount: withCoachUserId(oneToTwoCSBPClientCountById),
    fiveToSixCSBPClientCount: withCoachUserId(fiveToSixCSBPClientCountById),
    sevenToNineCSBPClientCount: withCoachUserId(sevenToNineCSBPClientCountById),
    eligibleClientSupportBonusPlusCount: withCoachUserId(
      bonusEligibleForClientSupportPlusById,
    ),
    eligibleForQsbCount: withCoachUserId(eligibleForQsbCountById),

    eligibleForIncentiveTrip: withCoachUserId(
      bonusEligibleForIncentiveTripById,
    ),
    rankUp: withCoachUserId(coachesRankUpById),
    earnedClientSupportBonusPlusCount: withCoachUserId(
      bonusEarnedClientSupportPlusById,
    ),
    earnedAccelBonusCount: withCoachUserId(bonusEarnedAccelById),

    featureFlag: variablesFeatureFlag,
    bonusDisplayDate: variablesBonusDisplayDate,
  }),
  _dispatch => ({}),
  (stateProps, dispatchProps, ownProps) => {
    const {bonusDisplayDate, featureFlag} = stateProps;

    /**  showCSBPlus -  check is to show CSB+ summary and report temporarily.
     if the current date falls on or before the end date, CSB+ summary tab will be visible */
    // This is in UTC time. it converts to 2024-12-31 2am ET

    const {CSBPlusReportEndDate: remopteConfigCSBPlusReportEndDate} =
      bonusDisplayDate;
    const endDate = remopteConfigCSBPlusReportEndDate || CSBPlusReportEndDate;

    const showCSBPlusBonusSummary =
      getDateUtilDefaultInstance().isDateSameOrBefore(endDate);
    const showIncentiveTrip = get(
      stateProps,
      'featureFlag.showEligibleIncentiveTrip',
      false,
    );
    const showEligibleQSB = get(
      stateProps,
      'featureFlag.showEligibleQSB',
      false,
    );
    const {
      ff_csb_plus_insights_filtering = '',
      showEnhancedCSBPlus = false,
      ff_new_coaches_acquiring_clients = '',
    } = featureFlag;
    const showCsbPlusInsightsFiltering = shouldReleaseFeature(
      ff_csb_plus_insights_filtering,
    );
    const NewCoachesAquiringClients = shouldReleaseFeature(
      ff_new_coaches_acquiring_clients,
    );
    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      showCSBPlus: showCSBPlusBonusSummary,
      showIncentiveTrip,
      showEligibleQSB,
      showCsbPlusInsightsFiltering,
      NewCoachesAquiringClients,
      showEnhancedCSBPlus,
    };
  },
)(BonusesSection);
